import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
export default function cn() {
  return twMerge(clsx(...arguments));
}
//# sourceMappingURL=cn.js.map